import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GetCard from "../cards/GetCard";
function Services() {
   return (
      <>
         <section className='services-area content-area'>
            <Container>
               <Row className='g-4'>
                  <Col xl={4}>
                     <GetCard variant='profile'/>
                  </Col>
                  <Col xl={8}>
                     <Row className='g-4'>
                        <Col lg={12}>
                           <GetCard variant='services' showAll={true}/>
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Container>
         </section>
      </>
   );
 }
 export default Services; 